import React from "react";
import { toolsRoutes } from "./routes";

import { AppRouterLimited } from "../shared/components/AppRouter";

export const ToolsRoutes = () => <AppRouterLimited routes={toolsRoutes} />;
